// extracted by mini-css-extract-plugin
module.exports = {"ad":"Right_ad__KzItq","container":"Right_container__3V5s0"};